module.exports = __webpack_public_path__ + "static/media/chula-learnhub.dceb25cd.png";